import { KeyRound } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { AI_KEY_MISSING_NOTICE, AI_KEY_SETTINGS_LINK_LABEL, AI_KEY_SETTINGS_PATH } from "@/lib/ai-key";
import { cn } from "@/lib/utils";

/**
 * TENANT-AIKEY-REQUIRED-01, CRED-COST-01: the refusal a clinic without its
 * CliniSharp-issued model key reads on an AI surface. It cannot be dismissed:
 * it stays until CliniSharp stores the key. An admin gets a link to the AI settings; other roles read plain
 * text. `link={false}` on the settings screen itself.
 */
export function AiKeyMissingNotice({ link = true, className }: { link?: boolean; className?: string }) {
  const { user } = useAuth();
  const admin = user?.roles?.some((role) => role.name === "admin") ?? false;

  return (
    <div role="alert" className={cn("rounded-xl border border-app-warning/40 bg-app-warning/10 p-3 text-left text-sm text-app-fg", className)}>
      <p className="flex items-start gap-2">
        <KeyRound className="mt-0.5 size-4 shrink-0 text-app-warning" aria-hidden="true" />
        <span>{AI_KEY_MISSING_NOTICE}</span>
      </p>
      {link && admin ? (
        <Link to={AI_KEY_SETTINGS_PATH} className="mt-2 inline-flex min-h-11 items-center font-medium text-brand underline-offset-4 hover:underline sm:min-h-10">
          {AI_KEY_SETTINGS_LINK_LABEL}
        </Link>
      ) : null}
    </div>
  );
}
